// enums
import { USER_GROUP_TYPE } from '@/enums';
//
import { BaseService } from '../BaseService';
import { UserGroupMetaResponseDto, UserGroupsSearchRequestDto } from './dto';
import { UserGroupSearchDto } from './dto/search/response.dto';

class UserGroupsService extends BaseService {
  postSearch({ page = 1, size = 20, userGroupType, searchText }: UserGroupsSearchRequestDto) {
    return this.post<UserGroupSearchDto[]>(
      `search`,
      {
        userGroupType,
        searchText,
      },
      {
        params: {
          page,
          size,
        },
      }
    );
  }

  getContents(userGroupId: number) {
    return this.get(`${userGroupId}/contents`);
  }
  getMeta(userGroupId: number) {
    return this.get<UserGroupMetaResponseDto>(`${userGroupId}/meta`);
  }

  getStripeStatus(userGroupId: number) {
    return this.get(`${userGroupId}/stripe-status`);
  }

  postLinkStripeAccount(userGroupId: number) {
    return this.post(`${userGroupId}/link-stripe-account`);
  }

  getPlans(userGroupType: USER_GROUP_TYPE) {
    return this.get(`plans`, { params: { userGroupType } });
  }

  getOnePlan(userGroupPlanId: number) {
    return this.get(`plans/${userGroupPlanId}`);
  }
}

export default new UserGroupsService('/user-groups');
